import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CyclopsHttp } from './app.http';

@Injectable({
  providedIn: 'root',
})
export class AumyeSecurityPassService {
  constructor(private cyclopsHttp: CyclopsHttp) {}
  getVisitorData(id: string): Observable<any> {
    return this.cyclopsHttp.get('GetVisitorSecurityPass', id);
  }
  getUserData(id: string): Observable<any> {
    return this.cyclopsHttp.get('GetUserDetails', id);
  }
  updateVisitorData(params: any): Observable<any> {
    return this.cyclopsHttp.post('UpdateVisitor', params);
  }
  hostVerificationGateEntry(params: any): Observable<any> {
    return this.cyclopsHttp.post('HostVerification', params);
  }
  // verifyUserIdentity(formData: FormData): Observable<any> {
  //   const userId = localStorage.getItem('UserId');
  //   return this.cyclopsHttp.post(`FaceRecognition?UserID=${userId}`, formData);
  // }
  verifyUserIdentity(data: any): Observable<any> {
    return this.cyclopsHttp.post(
      `FaceRecognition?UserID=${data.userId}`,
      data.formData
    );
  }
}
